import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  TRADE_MARK_ROYAL,
  TRADE_MARK_CELEBRITY,
  TRADE_MARK
} from '../../configuration/terms'

const getTrademark = brandLetter => {
  let text = ''

  switch (brandLetter) {
    case 'R':
      text = TRADE_MARK_ROYAL
      break

    case 'C':
      text = TRADE_MARK_CELEBRITY
      break

    default:
      text = TRADE_MARK
  }

  return text
}

const TradeMark = props => {
  let brand = props.brand
  if (!brand) {
    brand =
      props.currentBrands.size === 1
        ? Array.from(props.currentBrands)[0]
        : props.activeSearchFilterData.brand
  }
  const year = `&copy; ${moment().format('YYYY')}`
  let tradeMark = getTrademark(brand)
  tradeMark = tradeMark.replaceAll('<year>', year)
  return <span dangerouslySetInnerHTML={{ __html: tradeMark }} />
}

const mapStateToProps = state => {
  const activePackages = Object.keys(state.activePackageData)
  let currentBrands = new Set()
  activePackages.forEach(item => {
    const pkg =
      state.packagesData.allPackages?.[item] ||
      state.cruiseToursData.allPackages?.[item]
    if (pkg) {
      currentBrands.add(pkg.brand)
    }
  })

  return {
    activeSearchFilterData: state.activeSearchFilterData,
    currentBrands,
    ssoData: state.ssoData
  }
}

export default connect(mapStateToProps)(TradeMark)
